import React from 'react';
import PropTypes from 'prop-types';

import defaultImage from '../../../../images/Game/defaultImage.jpg';

// onError={(err) => { console.log(err); return `this.src='${defaultImage}'`; }}

const PlayerImage = React.memo(({
  photo, currentType, gameState, largePlayer,
}) => (
  <div className="player-avatar-wrapper">
    <div className={`player-avatar ${(currentType !== 'galdins' && (gameState === 'play' || gameState === 'burry')) && ' player-avatar-active'} ${largePlayer ? ' player-avatar-lielais' : ' player-avatar-mazais'}`}>
      <img src={photo || defaultImage} alt="" onError={(e) => { e.target.onerror = null; e.target.src = defaultImage; }} />
    </div>
  </div>
));

PlayerImage.propTypes = {
  photo: PropTypes.string,
  currentType: PropTypes.string,
  gameState: PropTypes.string,
  largePlayer: PropTypes.bool,
};

PlayerImage.defaultProps = {
  photo: null,
  currentType: null,
  gameState: null,
  largePlayer: false,
};

export default PlayerImage;
